import React from 'react';

import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';

import { RichText } from '@components/RichText/RichText';
import Loader from '@components/Loader/Loader';
import { useUser } from '@hooks/user/useUser';

import styles from './InvoiceInfo.module.scss';
import { checkUserSubsContractType } from '@helpers/checkUserSubsContractType';

export const InvoiceInfo = ({
  financeInfoText,
  rentalInfoText,
}: {
  financeInfoText: StoryblokRichtext;
  rentalInfoText: StoryblokRichtext;
}) => {
  const { data: user, isLoading } = useUser();
  if (isLoading) {
    // @ts-ignore
    return <Loader />;
  }

  const { hasUserFinanceSubs, hasUserRentalSubs } = checkUserSubsContractType(user);

  return (
    <div className={styles.container}>
      {hasUserFinanceSubs && <RichText document={financeInfoText} className={styles.text} />}
      {hasUserRentalSubs && <RichText document={rentalInfoText} className={styles.text} />}
    </div>
  );
};
